import React from 'react';

import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';
import {
  PaywallSectionSelectPlan,
  SimpleSelectPlan,
  OneDayVIPSelectPlan,
  OfferCardSelectPlan,
} from '@/pages/Paywall/sections/SelectPlan';

interface SelectPlanComponentSelectorProps {
  title: NonNullable<React.ReactNode> | null;
  vipTitle?: string;
  buttonProps: {
    text: string;
    onClick: () => void;
  };
  isPromoCodeVisible?: boolean;
  sectionId?: string;
}

export const SelectPlanComponentSelector: React.FC<
  SelectPlanComponentSelectorProps
> = ({
  title,
  vipTitle,
  buttonProps,
  isPromoCodeVisible = false,
  sectionId,
}) => {
  const { paywallNotes } = webCampaign.setup;

  if (paywallNotes.includes(PAYWALL_NOTES.OFFER_CARD_SELECT_PLAN)) {
    return (
      <OfferCardSelectPlan buttonProps={buttonProps} sectionId={sectionId} />
    );
  }

  if (paywallNotes.includes(PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN)) {
    return (
      <OneDayVIPSelectPlan
        vipTitle={vipTitle}
        buttonProps={buttonProps}
        sectionId={sectionId}
      />
    );
  }

  if (paywallNotes.includes(PAYWALL_NOTES.SIMPLE_SELECT_PLAN)) {
    return (
      <SimpleSelectPlan
        title={title}
        buttonProps={buttonProps}
        sectionId={sectionId}
      />
    );
  }

  return (
    <PaywallSectionSelectPlan
      title={title}
      buttonProps={buttonProps}
      isPromoCodeVisible={isPromoCodeVisible}
      sectionId={sectionId}
    />
  );
};
